import { IonImg, IonText } from "@ionic/react";
import { ComponentProps } from "react";
import { useIntl } from "react-intl";

import styles from "@components/text/PageTitle.module.css";
import Heading1 from "@components/typography/Heading1";
import { FocusAreaEnum } from "@typing/Generated";
import { imageUrl } from "@utils/imageUtils";

export type UsableImageName =
  | "bench"
  | "chess"
  | "dancing"
  | "employerList"
  | "givingGift"
  | "manReadingRadio"
  | "map"
  | "peopleCoffeeLight"
  | "peopleHoldingHearts"
  | "medicationGroup"
  | "womanPlan"
  | "womanWithCoffee"
  | FocusAreaEnum;

type Props = ComponentProps<typeof IonText> & {
  imageName: UsableImageName;
  title?: string;
  titleKey?: string | null;
};

const PageTitle = ({ imageName, title, titleKey }: Props) => {
  const intl = useIntl();

  const viewTopOfImage =
    imageName === "bench" ||
    imageName === "medicationGroup" ||
    imageName === "dancing" ||
    imageName === "manReadingRadio" ||
    imageName === "givingGift";

  const smallImage =
    imageName === "womanPlan" ||
    imageName === "womanWithCoffee" ||
    imageName === "employerList" ||
    imageName === "peopleHoldingHearts" ||
    Object.values(FocusAreaEnum).includes(imageName as FocusAreaEnum);

  return (
    <div className={styles.header} data-test="page-title">
      <div className={styles.bar}>
        <Heading1 className={styles.title}>{title ?? intl.formatMessage({ id: titleKey ?? "" })}</Heading1>
        <IonImg
          alt={intl.formatMessage({ id: `accessibility.altTags.${imageName}` })}
          className={viewTopOfImage ? styles.topOfImage : smallImage ? styles.smallImage : styles.image}
          slot="end"
          src={imageUrl(imageName)}
        />
      </div>
    </div>
  );
};

export default PageTitle;
